import httpUtils from '@/utils/http-utils';
import i18n from '@/plugins/vue-i18n';

const baseRequesterOptions = {
  baseUrl: `${window.processEnv.VUE_APP_CMS_API_BASE_URL}/subscriptions`,
  requesterType: 'CMS_WEB_SERVICE',
};
const subscriptionApiReqNotification = httpUtils.createRequester(baseRequesterOptions);
const subscriptionApiReqErrorHandling = httpUtils.createRequester(baseRequesterOptions, 'errorHandling');

const getRequester = (errorManagementType) => {
  if (errorManagementType === 'errorHandling') {
    return subscriptionApiReqErrorHandling;
  }

  return subscriptionApiReqNotification;
};

class SubscriptionApi {
  fetchSubscriptions(type, errorManagementType) {
    return getRequester(errorManagementType)
      .get('/', {
        headers: {
          'accept-language': i18n.locale,
        },
        params: {
          type,
        },
      }).then(res => res && res.data);
  }
}

export default new SubscriptionApi();
